module.exports = __webpack_public_path__ + "img/gb-eng.84b5f8c6.svg";